import { memo } from "react"
import styled from "styled-components"

const ControlSafe = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

const IconAsc = () => {
  return (
    <ControlSafe>
      <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 2.22211C0 1.24027 0.795938 0.444336 1.77778 0.444336H12.4444C13.4263 0.444336 14.2222 1.24027 14.2222 2.22211V4.88878C14.2222 5.87062 13.4263 6.66656 12.4444 6.66656H1.77778C0.795938 6.66656 0 5.87062 0 4.88878V2.22211Z"
          fill="#646464"
        />
        <path
          d="M0 11.111C0 10.1292 0.795938 9.33322 1.77778 9.33322H12.4444C13.4263 9.33322 14.2222 10.1292 14.2222 11.111V13.7777C14.2222 14.7595 13.4263 15.5554 12.4444 15.5554H1.77778C0.795938 15.5554 0 14.7595 0 13.7777V11.111Z"
          fill="#646464"
        />
        <path
          d="M19.1117 8.25814C19.0306 8.25807 18.953 8.22583 18.8957 8.16851L16.0439 5.31666C15.9675 5.23806 15.9388 5.12467 15.9686 5.01919C15.9985 4.91371 16.0824 4.83218 16.1886 4.8053C16.2949 4.77842 16.4075 4.81028 16.4839 4.88888L19.1117 7.51666L21.7394 4.88888C21.8156 4.80713 21.9303 4.77348 22.0386 4.80113C22.1468 4.82878 22.2314 4.91332 22.259 5.02158C22.2867 5.12984 22.253 5.24456 22.1713 5.32073L19.3194 8.17259C19.2636 8.22646 19.1893 8.25705 19.1117 8.25814Z"
          fill="#646464"
        />
        <path
          d="M19.1117 8.25407C18.9438 8.25187 18.8083 8.11635 18.8061 7.94851V1.8374C18.8061 1.72824 18.8643 1.62736 18.9589 1.57278C19.0534 1.5182 19.1699 1.5182 19.2644 1.57278C19.359 1.62736 19.4172 1.72824 19.4172 1.8374V7.94851C19.415 8.11635 19.2795 8.25187 19.1117 8.25407Z"
          fill="#646464"
        />
        <path
          d="M19.1117 8.25814C19.0306 8.25807 18.953 8.22583 18.8957 8.16851L16.0439 5.31666C15.9675 5.23806 15.9388 5.12467 15.9686 5.01919C15.9985 4.91371 16.0824 4.83218 16.1886 4.8053C16.2949 4.77842 16.4075 4.81028 16.4839 4.88888L19.1117 7.51666L21.7394 4.88888C21.8156 4.80713 21.9303 4.77348 22.0386 4.80113C22.1468 4.82878 22.2314 4.91332 22.259 5.02158C22.2867 5.12984 22.253 5.24456 22.1713 5.32073L19.3194 8.17259C19.2636 8.22646 19.1893 8.25705 19.1117 8.25814Z"
          fill="#646464"
        />
        <path
          d="M19.1117 8.25407C18.9438 8.25187 18.8083 8.11635 18.8061 7.94851V1.8374C18.8061 1.72824 18.8643 1.62736 18.9589 1.57278C19.0534 1.5182 19.1699 1.5182 19.2644 1.57278C19.359 1.62736 19.4172 1.72824 19.4172 1.8374V7.94851C19.415 8.11635 19.2795 8.25187 19.1117 8.25407Z"
          fill="#646464"
        />
        <path
          d="M19.1117 8.25814C19.0306 8.25807 18.953 8.22583 18.8957 8.16851L16.0439 5.31666C15.9675 5.23806 15.9388 5.12467 15.9686 5.01919C15.9985 4.91371 16.0824 4.83218 16.1886 4.8053C16.2949 4.77842 16.4075 4.81028 16.4839 4.88888L19.1117 7.51666L21.7394 4.88888C21.8156 4.80713 21.9303 4.77348 22.0386 4.80113C22.1468 4.82878 22.2314 4.91332 22.259 5.02158C22.2867 5.12984 22.253 5.24456 22.1713 5.32073L19.3194 8.17259C19.2636 8.22646 19.1893 8.25705 19.1117 8.25814Z"
          stroke="#646464"
          stroke-width="0.5"
        />
        <path
          d="M19.1117 8.25407C18.9438 8.25187 18.8083 8.11635 18.8061 7.94851V1.8374C18.8061 1.72824 18.8643 1.62736 18.9589 1.57278C19.0534 1.5182 19.1699 1.5182 19.2644 1.57278C19.359 1.62736 19.4172 1.72824 19.4172 1.8374V7.94851C19.415 8.11635 19.2795 8.25187 19.1117 8.25407Z"
          stroke="#646464"
          stroke-width="0.5"
        />
        <path
          d="M19.1117 8.25814C19.0306 8.25807 18.953 8.22583 18.8957 8.16851L16.0439 5.31666C15.9675 5.23806 15.9388 5.12467 15.9686 5.01919C15.9985 4.91371 16.0824 4.83218 16.1886 4.8053C16.2949 4.77842 16.4075 4.81028 16.4839 4.88888L19.1117 7.51666L21.7394 4.88888C21.8156 4.80713 21.9303 4.77348 22.0386 4.80113C22.1468 4.82878 22.2314 4.91332 22.259 5.02158C22.2867 5.12984 22.253 5.24456 22.1713 5.32073L19.3194 8.17259C19.2636 8.22646 19.1893 8.25705 19.1117 8.25814Z"
          stroke="#646464"
          stroke-width="0.5"
        />
        <path
          d="M19.1117 8.25407C18.9438 8.25187 18.8083 8.11635 18.8061 7.94851V1.8374C18.8061 1.72824 18.8643 1.62736 18.9589 1.57278C19.0534 1.5182 19.1699 1.5182 19.2644 1.57278C19.359 1.62736 19.4172 1.72824 19.4172 1.8374V7.94851C19.415 8.11635 19.2795 8.25187 19.1117 8.25407Z"
          stroke="#646464"
          stroke-width="0.5"
        />
      </svg>
    </ControlSafe>
  )
}

export default memo(IconAsc)
